import { __rest } from '../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import React__default, { Suspense } from 'react';
import { StyledSelectWrapper } from './Select.styles.js';
import { ContainerComponent, DropdownIndicatorComponent, ControlComponent, SingleValueComponent, NoOptionsMessageComponent, OptionComponent, InputComponent, ValueComponent, PlaceholderComponent, ClearIconComponent } from './RSelectDerived.js';
import Typography from '../Typography/Typography.js';
import COLORS from '../../constants/colors.js';
import { Flex } from '../../layout/Flex.js';

const ReactSelect = React__default.lazy(() => import('react-select'));
const ReactCreatableSelect = React__default.lazy(() => import('react-select/creatable'));
const Select = React__default.forwardRef((props, ref) => {
    const { id, name, label, headingLabel, headingLabelStyleProps, errorMsg, option, required, noOptionText, noOptionHandler, labelFormatter, value = null, outline = "border", menuPlacement = "auto", menuPosition = "fixed", size = "md", components } = props, restCommonProps = __rest(props, ["id", "name", "label", "headingLabel", "headingLabelStyleProps", "errorMsg", "option", "required", "noOptionText", "noOptionHandler", "labelFormatter", "value", "outline", "menuPlacement", "menuPosition", "size", "components"]);
    const commonProps = Object.assign({ "aria-label": label, name, id: `${id}__container`, inputId: `${id}__input`, instanceId: id, ref,
        value, options: option, menuPlacement,
        menuPosition, components: Object.assign({ SelectContainer: ContainerComponent, DropdownIndicator: DropdownIndicatorComponent, Control: ControlComponent, SingleValue: SingleValueComponent, NoOptionsMessage: NoOptionsMessageComponent, Option: OptionComponent, Input: InputComponent, IndicatorSeparator: null, ValueContainer: ValueComponent, Placeholder: PlaceholderComponent, ClearIndicator: ClearIconComponent }, components), noOptionsMessage: noOptionHandler !== null && noOptionHandler !== void 0 ? noOptionHandler : (() => noOptionText !== null && noOptionText !== void 0 ? noOptionText : "No Option"), formatOptionLabel: labelFormatter }, restCommonProps);
    const getElementByType = () => {
        switch (props.type) {
            case "common": {
                return (jsx(Suspense, Object.assign({ fallback: null }, { children: jsx(ReactSelect, Object.assign({}, commonProps)) })));
            }
            case "creatable": {
                const { onCreateOption, getNewOptionData, isValidNewOption, formatCreateLabel, createOptionPosition, } = props;
                const creatableProps = {
                    onCreateOption,
                    getNewOptionData,
                    isValidNewOption,
                    formatCreateLabel,
                    createOptionPosition,
                };
                return (jsx(Suspense, Object.assign({ fallback: null }, { children: jsx(ReactCreatableSelect, Object.assign({}, commonProps, creatableProps)) })));
            }
            default: {
                return null;
            }
        }
    };
    return (jsxs(Flex, Object.assign({ flexDirection: "column", gap: 12 }, { children: [jsx(Typography, Object.assign({ color: COLORS.GREY_900, required: required }, headingLabelStyleProps, { children: headingLabel })), jsx(StyledSelectWrapper, Object.assign({ outline: outline, size: size }, { children: getElementByType() })), jsx(Typography, Object.assign({ color: COLORS.RED, size: "s" }, { children: errorMsg }))] })));
});
Select.defaultProps = {
    type: "common",
};

export { Select as default };
//# sourceMappingURL=Select.js.map
